module.exports = __webpack_public_path__ + "static/media/login-bg.c6dc935f.svg";